import { ENDPOINT } from '~/constants';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  type CostCentersAdminQueryParams,
  type CostCentersAdminResponse,
} from './types';
import {
  zodCostCentersAdminQueryParamsSchema,
  zodCostCentersAdminResponseSchema,
} from './validations';

/**
 * Fetches one page of the cross-tenant accounting-reference directory (vadmin
 * only): name/id search, optional company-account scope, optional single-id
 * lookup.
 *
 * @param queryParameters - Search string, scope, id and page of the listing.
 * @param options - Additional request options (e.g. abort signal).
 * @returns One page of accounting references in the pagination envelope.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Directory/operation/get_accounting_references_directory_vadmin_accounting_reference_get
 */
export const fetchCostCentersAdmin = async (
  queryParameters: CostCentersAdminQueryParams = {},
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.COST_CENTER.GET_ALL_ADMIN(), {
      searchParams: queryParameters,
      ...options,
      validate: {
        ...options?.validate,
        response: zodCostCentersAdminResponseSchema,
        searchParams: zodCostCentersAdminQueryParamsSchema,
      },
    })
    .json<CostCentersAdminResponse>();
